import type { Exercise } from './Exercise'
import type { Note } from './Note'
export type LessonItem = Exercise | Note

export function isNoteItem(item: LessonItem): item is Note {
    return item.kind === 'note'
}

export function isExerciseItem(item: LessonItem): item is Exercise {
    return item.kind !== 'note'
}
